import React, { useState, useEffect, useRef, useMemo } from 'react';
import './TeamSection.css';
import MonstaImg from '../images/Monsta.webp';
import BradkenImg from '../images/Bradken.webp';

const TeamSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2, rootMargin: '50px' }
    );

    const currentSection = sectionRef.current;

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  const teamMembers = useMemo(() => [
    {
      role: 'Creator',
      name: 'Monsta',
      image: MonstaImg,
      isCreator: true
    },
    {
      role: 'Website Developer',
      name: 'OxBradken',
      image: BradkenImg,
      isCreator: false
    }
  ], []);

  const title = "THE TEAM";

  return (
    <section className="team-section" ref={sectionRef}>
      <h2 className={`team-title ${isVisible ? 'visible' : ''}`}>
        {title.split('').map((char, idx) => (
          <span
            key={idx}
            className="title-letter"
            style={{ animationDelay: `${idx * 0.08}s` }}
          >
            {char === ' ' ? '\u00A0' : char}
          </span>
        ))}
      </h2>

      <div className="team-container">
        {teamMembers.map((member, index) => (
          <div 
            key={index}
            className={`team-card ${member.isCreator ? 'creator-card' : ''} ${isVisible ? 'visible' : ''}`}
            style={{ animationDelay: `${0.3 + index * 0.15}s` }}
          >
            <h3 className="team-role">{member.role}</h3>
            <div className="team-pfp-container">
              <img 
                src={member.image} 
                alt={member.name} 
                className="team-pfp"
                loading="lazy"
              />
            </div>
            <p className="team-name">{member.name}</p>
          </div>
        ))}
      </div>

      <div className={`vision-box ${isVisible ? 'visible' : ''}`}>
        <h3 className="vision-title">OUR VISION</h3>
        <p className="vision-text">
          Monsta believes in strengthening the <span className="highlight">Hedera Network</span> through community engagement! What better way to do that than by representing your digital identity with fun, yet edgy and downright badass NFT's! If you consider yourself an HBAR enthusiast then this collection is for you! Not only do the Angry Aliens represent Hedera, they represent many projects who have built on Hedera! Monsta will be using the royalties derived from this collection to give back to the community through wheel spin giveaways!
        </p>
      </div>
    </section>
  );
};

export default TeamSection;